import chalk from "chalk";

class SimpleLogger {
    private readonly moduleName: string;

    constructor(moduleName: string) {
        this.moduleName = moduleName + " " || "";
    }

    log(...args: any[]): void {
        const [arg1, ...rest] = args;
        this._log(arg1, rest, "INFO", "blue");
    }

    trace(...args: any[]): void {
        this.log(...args);
    }

    error(message: string, ...args: any[]): void {
        this._log(message, args, "ERROR", "red");
    }

    colorLog(text: string, consoleCss?: string): void {
        console.log(text, consoleCss);
    }

    private _log(message: any, args: any[], logType = "", color = "blue"): void {
        for (const arg of args) {
            const value = typeof arg === "string" ? arg : JSON.stringify(arg);
            message = message.replace("%s", value);
        }

        if (typeof message === "object") {
            message = JSON.stringify(message, null, 2);
        }

        message = logType + (logType && this.moduleName ? ":" : "") + this.moduleName + message;

        switch (color) {
            case "blue":
                console.log(chalk.blue(message));
                return;
            case "red":
                console.log(chalk.red(message));
                return;
            default:
                throw Error("Unknown log color: " + color)
        }
    }
}

export default SimpleLogger;
